module.exports = __webpack_public_path__ + "img/21.ce2563ef.svg";